exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".full[data-v-1f3dc432]{width:100%;height:100%}", ""]);

// exports
